module.exports = __webpack_public_path__ + "img/netCelebrityBanner.6ecf3aeb.jpg";